<template>
  <div v-if="enabled">
    <ul
      class="nav nav-tabs menu-tabs mb-3"
      :class="{ 'loading-tabs': isLoading }"
    >
      <li
        v-for="tab in visibleTabs"
        :key="tab.key"
        class="nav-item"
        :class="{ active: activeTab === tab.key }"
      >
        <router-link class="nav-link" :to="isLoading ? '#' : tab.route">
          {{ tab.label ? tab.label : $t(tab.translationKey) }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'GenericTabs',
  props: {
    activeTab: String,
    enabled: {
      type: Boolean,
      default: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    modules: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Object,
      default: () => ({}),
    },
    locale: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    visibleTabs() {
      return this.tabs.filter(tab => {
        // Check if hidden
        if (tab.hidden) return false;

        // Check permissions
        if (tab.requiredPermission && !this.permissions[tab.requiredPermission]) return false;

        // Check module availability
        if (tab.module && !this.modules.includes(tab.module)) return false;

        // Check locale
        if (tab.locale && tab.locale !== this.locale) return false;

        // Custom visibility condition
        if (tab.visible && typeof tab.visible === 'function' && !tab.visible(this)) return false;

        return true;
      });
    },
  },
};
</script>

<style scoped>
.loading-tabs {
  pointer-events: none;
  opacity: 0.8; /* Increased from 0.6 to make it more visible */
}
</style>



// WEBPACK FOOTER //
// src/components/shared/GenericTabs.vue